import moment from 'moment';
import queryString from 'qs';

export const getReportSessionRequest = (queryParams) => {
  const queries = { limit: 10, page: queryParams?.page };

  if (queryParams?.session?.startedAt) queries['startedAt'] = moment(queryParams?.session?.startedAt).format('YYYY-MM-DD');
  if (queryParams?.session?.endedAt) queries['endedAt'] = moment(queryParams?.session?.endedAt).format('YYYY-MM-DD');
  if (queryParams?.session?.brand?.length) queries['brandName'] = `[${queryParams?.session?.brand?.map((item) => item?.value)}]`;
  if (queryParams?.session?.platform?.length) queries['accountLivestreams.ecommerce.id'] = `[${queryParams?.session?.platform?.map((item) => item?.value)}]`;
  if (queryParams?.session?.account?.length) queries['accountLivestreams.name'] = `[${queryParams?.session?.account?.map((item) => item?.label)}]`;
  if (queryParams?.search) queries['search'] = queryParams?.search;
  if (queryParams?.sort) queries['sort'] = `${queryParams?.sort?.field}.${queryParams?.sort?.order}`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getReportSessionRequest;
